import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

/**
 * Formats an image URL from the Auxo asset CDN to use Cloudflare on-the-fly resizing.
 * 
 * @param {string} url - The original image URL.
 * @param {string} options - Cloudflare resizing options (e.g., 'width=800,quality=80,format=auto').
 * @returns {string} The resized image URL.
 */
export function getResizedImageUrl(url, options = 'width=800,quality=80,format=auto') {
  if (!url) return '';
  
  // Ensure we only rewrite URLs from our asset CDN
  if (url.startsWith('https://assets.auxodev.dk/')) {
    // Avoid double-wrapping if it already contains /cdn-cgi/image/
    if (url.includes('/cdn-cgi/image/')) {
      return url;
    }
    return url.replace('https://assets.auxodev.dk/', `https://assets.auxodev.dk/cdn-cgi/image/${options}/`);
  }
  
  return url;
}

/**
 * Updates the document title and meta description dynamically.
 * 
 * @param {string} title - The page title.
 * @param {string} description - The page meta description.
 */
export function updateMetaTags(title, description) {
  if (title) {
    document.title = title;
  }
  if (description) {
    let metaDesc = document.querySelector('meta[name="description"]');
    if (!metaDesc) {
      metaDesc = document.createElement('meta');
      metaDesc.setAttribute('name', 'description');
      document.head.appendChild(metaDesc);
    }
    metaDesc.setAttribute('content', description);
  }
}
